import { useTheme } from "@mui/material/styles";

type LockIconProps = {
  locked: boolean;
  color?: "green" | "gray" | "orange";
};

const LockIcon = ({ locked = false, color = "gray" }: LockIconProps) => {
  const theme = useTheme();

  let stroke = theme.palette.primary.main;

  switch (color) {
    case "green":
      stroke = theme.palette.primary.main;
      break;
    case "gray":
      stroke = theme.palette.otherStandardInputLine.main;
      break;
    case "orange":
      stroke = theme.palette.warning.main;
      break;
  }

  if (locked) {
    return (
      <svg
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.36662 5.36686V4.03353C9.36662 2.19258 7.87423 0.700195 6.03328 0.700195C4.19234 0.700195 2.69995 2.19258 2.69995 4.03353V5.36686M6.03328 8.36686V9.7002M3.89995 12.7002H8.16662C9.28672 12.7002 9.84678 12.7002 10.2746 12.4822C10.6509 12.2905 10.9569 11.9845 11.1486 11.6082C11.3666 11.1804 11.3666 10.6203 11.3666 9.5002V8.56686C11.3666 7.44676 11.3666 6.8867 11.1486 6.45888C10.9569 6.08256 10.6509 5.7766 10.2746 5.58485C9.84678 5.36686 9.28672 5.36686 8.16662 5.36686H3.89995C2.77985 5.36686 2.21979 5.36686 1.79197 5.58485C1.41565 5.7766 1.10968 6.08256 0.917938 6.45888C0.699951 6.8867 0.699951 7.44676 0.699951 8.56686V9.5002C0.699951 10.6203 0.699951 11.1804 0.917938 11.6082C1.10968 11.9845 1.41565 12.2905 1.79197 12.4822C2.21979 12.7002 2.77985 12.7002 3.89995 12.7002Z"
          stroke={stroke}
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.69995 5.36686V4.03353C2.69995 2.19258 4.19234 0.700195 6.03328 0.700195C7.40016 0.700195 8.57488 1.52293 9.08926 2.7002M6.03328 8.36686V9.7002M3.89995 12.7002H8.16662C9.28672 12.7002 9.84678 12.7002 10.2746 12.4822C10.6509 12.2905 10.9569 11.9845 11.1486 11.6082C11.3666 11.1804 11.3666 10.6203 11.3666 9.5002V8.56686C11.3666 7.44676 11.3666 6.8867 11.1486 6.45888C10.9569 6.08256 10.6509 5.7766 10.2746 5.58485C9.84678 5.36686 9.28672 5.36686 8.16662 5.36686H3.89995C2.77985 5.36686 2.21979 5.36686 1.79197 5.58485C1.41565 5.7766 1.10968 6.08256 0.917938 6.45888C0.699951 6.8867 0.699951 7.44676 0.699951 8.56686V9.5002C0.699951 10.6203 0.699951 11.1804 0.917938 11.6082C1.10968 11.9845 1.41565 12.2905 1.79197 12.4822C2.21979 12.7002 2.77985 12.7002 3.89995 12.7002Z"
        stroke={stroke}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LockIcon;
